import { useState } from "react";
import { bool } from "prop-types";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { MAX_VERSIONS } from "@utils";
import { useEditorWebsocket } from "@hooks";
import { useEstimateComments, useEstimateEditorStore } from "@tools";
import { Alert, Button } from "@components";
import { CircularProgress, Tooltip } from "@material-ui/core";
import { Add } from "@material-ui/icons";


export const NewVersionButton = observer(({
  rememberScroll,
}) => {
  const { t } = useTranslation();
  const editorStore = useEstimateEditorStore();
  const commentStore = useEstimateComments();
  const socket = useEditorWebsocket();
  
  const [commentDialogVisible, showCommentDialog] = useState(false);
  const [showLimitAlert, setShowLimitAlert] = useState(false);
  
  const {
    estimateVersions,
    newVersionLoading,
    currentVersionName,
  } = editorStore;
  
  const handleNewVersionAdd = () => {
    if (newVersionLoading)
      return;
    
    if(estimateVersions?.length >= MAX_VERSIONS) {
      setShowLimitAlert(true);
      return;
    }
    
    if(commentStore.visibleGroupComments(editorStore.currentVersionKey).length)
      showCommentDialog(true);
    else
      createNewVersion();
  };
  
  const handleNewVersionAddWithComments = (copyComments) => {
    showCommentDialog(false);
    createNewVersion(copyComments);
  };
  
  const createNewVersion = (copyComments) => {
    if (newVersionLoading)
      return;
    editorStore.setNewVersionLoading();
    socket?.requestNewVersion(copyComments, rememberScroll);
  }
  
  return (
    <>
      <Tooltip title="Add new version" arrow placement="bottom">
        <Button
          icon={
            newVersionLoading ? <CircularProgress size={24} /> : <Add />
          }
          onClick={handleNewVersionAdd}
          className="noDrag m-1 p-1 border-dashed"
          variant="outlined"
          size="large"
        />
      </Tooltip>
      <Alert
        isOpen={showLimitAlert}
        title={t("alerts.editor.version_limit.title")}
        acceptText={t("common.close")}
        onAccept={() => setShowLimitAlert(false)}
      >
        { t("alerts.editor.version_limit.text", { limit: MAX_VERSIONS }) }
      </Alert>
      <Alert
        isOpen={commentDialogVisible}
        title={t("views.editor.versioning.copy_comments", { name: currentVersionName })}
        onAccept={() => handleNewVersionAddWithComments(true)}
        onCancel={() => handleNewVersionAddWithComments(false)}
        acceptText={t("common.yes")}
        cancelText={t("common.no")}
      />
    </>
  )
})

NewVersionButton.propTypes = {
  rememberScroll: bool,
}